/**
 * Auth Zustand store — global session state.
 * Persists JWT in localStorage (tradeoff vs httpOnly cookie:
 * MVP simplicity; revisit при выходе на prod — Q076 backend ready for cookie mode).
 */
import { create } from 'zustand'
import type { UserProfile, TokenResponse } from '@/api/auth'

interface AuthState {
  token: string | null
  user: UserProfile | null
  isAuthed: boolean
  setSession: (res: TokenResponse) => void
  setUser: (u: UserProfile) => void
  logout: () => void
  hydrate: () => void
}

export const useAuth = create<AuthState>((set) => ({
  token: null,
  user: null,
  isAuthed: false,

  setSession: (res) => {
    localStorage.setItem('auth_token', res.access_token)
    localStorage.setItem('auth_user', JSON.stringify(res.user))
    set({ token: res.access_token, user: res.user, isAuthed: true })
  },

  setUser: (u) => {
    localStorage.setItem('auth_user', JSON.stringify(u))
    set({ user: u, isAuthed: true })
  },

  logout: () => {
    localStorage.removeItem('auth_token')
    localStorage.removeItem('auth_user')
    set({ token: null, user: null, isAuthed: false })
  },

  hydrate: () => {
    const token = localStorage.getItem('auth_token')
    const userStr = localStorage.getItem('auth_user')
    if (token && userStr) {
      try {
        set({ token, user: JSON.parse(userStr) as UserProfile, isAuthed: true })
      } catch {
        localStorage.removeItem('auth_token')
        localStorage.removeItem('auth_user')
      }
    }
  },
}))
